<template>
  <page class="stay">
    <header-component
      :is-sticky="true"
      :logo="logoType"
      :content-props="{
        joinPage: true,
        hasLoginLink: true,
        inviteCode,
        signupPopupEnabled: true,
        cta: !isUserLoggedIn
          ? {
              copy: $t('cta'),
              openSignup: true,
              data: {
                'login-path': loginPath,
                'signup-path': signupPath
              }
            }
          : null
      }"
    />

    <section>
      <hero-section class="mb-10 l:mb-7" />

      <template v-if="!didUserJustLoginOrSignup">
        <format-banner-section />

        <pricing-card class="mt-8" />

        <buttons-section class="text-center mt-8 container" :invite-code="inviteCode" :show-signup="!isUserLoggedIn" />

        <benefits class="mt-4" />

        <organisations-category-explorer :categories="categoryProps" />

        <app-reviews :show-trial-end-date="false" :modifiers="['pt-0']">
          <template v-slot:cta>
            <buttons-section :invite-code="inviteCode" :show-signup="!isUserLoggedIn" />
          </template>
        </app-reviews>

        <faq type="b2cMultiUserPlan" />
      </template>
    </section>
  </page>
</template>

<script>
import Page from "@/shared/page"
import HeaderComponent from "@/features/header/components"
import Faq from "@/features/expendable-faq/expendable-faq"
import { mapGetters } from "vuex"
import { getLastPathParam, getSearchParam } from "@/utils/location"
import HeroSection from "@/pages/organisations/components/hero-section"
import FormatBannerSection from "@/pages/organisations/components/format-banner-section"
import ButtonsSection from "@/pages/organisations/components/buttons-section"
import PricingCard from "@/pages/organisations/components/pricing-card"
import AppReviews from "@/features/app-reviews"
import Benefits from "@/features/main-features-section/benefits"
import OrganisationsCategoryExplorer from "@/pages/organisations/components/category-explorer"
import globals from "@/utils/globals"

export default {
  name: "OrganisationsJoin",
  components: {
    FormatBannerSection,
    PricingCard,
    ButtonsSection,
    HeroSection,
    Page,
    HeaderComponent,
    Faq,
    AppReviews,
    Benefits,
    OrganisationsCategoryExplorer
  },
  props: {
    categoryProps: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      logoType: null
    }
  },
  computed: {
    ...mapGetters(["isUserLoggedIn", "usersEmail"]),
    didUserJustLoginOrSignup() {
      return getSearchParam("fromLoginSignup") === "true"
    },
    inviteCode() {
      return getLastPathParam()
    },
    joinPathAfterLoginOrSignup() {
      return this.inviteCode ? `/${this.$i18n.locale}/nc/join/${this.inviteCode}?fromLoginSignup=true` : ""
    },
    signupPath() {
      return `${globals.routes.signup}?last_page_before_login=${encodeURIComponent(this.joinPathAfterLoginOrSignup)}`
    },
    loginPath() {
      return `${globals.routes.login}?last_page_before_login=${encodeURIComponent(this.joinPathAfterLoginOrSignup)}`
    }
  },
  mounted() {
    this.getLogoType()
    window.addEventListener("resize", this.getLogoType)
    return this.$store.dispatch("loadUsersAccounts")
  },
  methods: {
    getLogoType() {
      this.logoType = window && window.innerWidth <= 375 ? "no-text-2" : "full"
    }
  },
  i18n: {
    messages: {
      en: {
        cta: "Create account"
      },
      de: {
        cta: "Konto erstellen"
      }
    }
  }
}
</script>
